import { createSelector } from 'reselect';

const selectRevenue = (state) => state.revenueNew;

export const selectRevenueInMonth = createSelector(
  [selectRevenue],
  (revenue) => revenue.revenueInMonth,
);
